import { Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';

type FooterContainerProps = {
  footer: string;
};

const FooterContainer = (props: FooterContainerProps) => {
  const { footer } = props;
  return (
    <Typography variant={'p4'} className={styles.footerText}>
      {footer}
    </Typography>
  );
};

export default FooterContainer;
